import * as PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import HelperService from '../../../../services/HelperService';
import { appSlice } from '../../../../store/slices';
import './PortfolioCard.scss';

const EYE_ICON_SIZE = 16;

const PortfolioCard = ({ namePorfolio, balance = '' }) => {
	const dispatch = useDispatch();
	const viewsBalances = useSelector(state => state?.app?.viewsBalances);

	return (
		<div className='Portfolio-Card'>
			<Icon className='card-bg' type={Icons.CryptoPortfolioBg} />

			<div className='card-top'>
				<div className='name'>{namePorfolio}</div>
				<Icon
					onClick={() => dispatch(appSlice.actions.setViewsBalances(!viewsBalances))}
					type={Icons[viewsBalances ? 'EYE' : 'CROSSED_EYE']}
					width={EYE_ICON_SIZE}
					height={EYE_ICON_SIZE}
				/>
			</div>
			<div className='card-bottom'>$ {viewsBalances ? HelperService.FormatFiatWithoutCurrency(balance) : '******'}</div>
		</div>
	);
};

PortfolioCard.propTypes = {
	nameWallet: PropTypes.node,
	namePorfolio: PropTypes.node,
	balance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PortfolioCard;
